import { NavigationRow } from 'components/eventView/navigation/NavigationRow';
import React, { useContext, useEffect, useRef } from 'react';
import { CtxEventView } from 'session/ctxEventView';
import styled, { CSSProperties, css } from 'styled-components/macro';

interface Props {
    background: CSSProperties;
    children: React.ReactNode;
    className?: string;
}

export const MobilePageLayout = (props: Props) => {
    const ref = useRef<HTMLDivElement>();
    const ctxEventView = useContext(CtxEventView);

    const isWide = ctxEventView.isWide;

    useEffect(() => {
        document.getElementsByTagName('html')[0].classList.add('no-scroll');

        return () => {
            document.getElementsByTagName('html')[0].classList.remove('no-scroll');
        };
    }, [isWide]);

    function dev() {
        console.log('CtxEvent', ctxEventView);
    }

    return (
        <S_MobilePageLayout className={props.className}>
            <S_MainContent
                $isWide={isWide}
                style={props.background}
                ref={ref}
                id="scrollmobilelanding"
            >
                {props.children}
            </S_MainContent>
            {!ctxEventView.mobileMenuOpen && (
                <S_Wrap>
                    <S_NavigationBar scrollContentRef={ref} />
                </S_Wrap>
            )}
            {(window.location.href.includes('localhost') ||
                window.location.href.includes('ngrok')) && <S_DevTools onClick={dev} />}
        </S_MobilePageLayout>
    );
};

const S_MobilePageLayout = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    flex-direction: column;
    background: #f1f2f4;
`;

const S_MainContent = styled.div<{ $isWide: boolean }>`
    overscroll-behavior-y: none;
    min-height: 100vh;
    flex: 1;
    overflow-y: auto;
    overflow-x: hidden;
    padding-bottom: 78px;
    background-size: cover;
    ${(props) => {
        if (props.$isWide) {
            return css`
                background-image: unset;
            `;
        }
    }}
`;

const S_Wrap = styled.div`
    position: fixed;
    bottom: 5px;
    width: 100%;
    z-index: 100;
    padding: 0 5px;
`;

const S_NavigationBar = styled(NavigationRow)`
    width: 100%;
`;

const S_DevTools = styled.div`
    position: absolute;
    width: 20px;
    height: 20px;
    bottom: 0px;
    left: 20px;
    background-color: orange;
    cursor: pointer;
    z-index: 9999999999;
`;
